import { render, staticRenderFns } from "./Estatuto.vue?vue&type=template&id=31101658&scoped=true&"
import script from "./Estatuto.vue?vue&type=script&lang=js&"
export * from "./Estatuto.vue?vue&type=script&lang=js&"
import style0 from "./Estatuto.vue?vue&type=style&index=0&id=31101658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31101658",
  null
  
)

export default component.exports